// extracted by mini-css-extract-plugin
export default {"tooltip":"VB-z","arrow":"WB-z"};